import { render, staticRenderFns } from "./UserEditPhones.vue?vue&type=template&id=521ce50a&xmlns%3Ab-row=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&"
import script from "./UserEditPhones.vue?vue&type=script&lang=js&"
export * from "./UserEditPhones.vue?vue&type=script&lang=js&"
import style0 from "./UserEditPhones.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports